import React from 'react';

import SEO from '@components/SEO';
import { routeToHome } from '@helpers';

const Backend = () => {
  routeToHome();
  return <SEO image={`static/skill-verified-og-backend.jpg`} />;
};

export default Backend;
